import { ENV } from '@/lib/env';

// TODO: Check if we need this
export const LOCALIZED_TARGET_INDICATOR_STRING = {
  'same as': 'same as',
  above: 'above',
  below: 'below',
};

export const UNIT_SELECT_OPTS = {
  percentage: 'percentage',
  weight: 'weight',
};

export const SUPPORTED_LANGUAGES = ['de', 'en', 'es', 'nl'] as const;

export enum AVERAGE_TYPES {
  ABOVE = 'above',
  EQUAL = 'equal',
  BELOW = 'below',
  UNKNOWN = 'unknown',
}

export const PROCESSING_COMPARISON = {
  [AVERAGE_TYPES.ABOVE]: {
    color: 'var(--color-cyan-5)',
    tagColor: 'var(--color-cyan-8)',
    tagBackground: 'var(--color-above-average-bg)',
  },
  [AVERAGE_TYPES.EQUAL]: {
    color: 'var(--color-cyan-7)',
    tagColor: 'var(--color-cyan-9)',
    tagBackground: 'var(--color-meets-average-bg)',
  },
  [AVERAGE_TYPES.BELOW]: {
    color: 'var(--color-cyan-9)',
    tagColor: 'var(--color-cyan-10)',
    tagBackground: 'var(--color-below-average-bg)',
  },
  [AVERAGE_TYPES.UNKNOWN]: {
    color: 'var(--color-gray-4)',
    tagColor: 'var(--color-gray-8)',
    tagBackground: 'var(--color-gray-3)',
  },
};

export enum PROGRESS_STAT_CARD_LAYOUT {
  DEFAULT,
  FULL,
  SIMPLE,
}

/** This needs to be updated when the data team updates the data */
export const BENCHMARK_YEAR_TO_COMPARE = process.env.NODE_ENV !== ENV.PRODUCTION ? 2021 : 2024;

export const DEFAULT_NAMESPACES = ['common', 'filters', 'nav', 'settings', 'insights'] as const;
